export * from './norway-logo.component';
